import { Component } from '@angular/core';

@Component({
	selector: 'app-partnership',
	templateUrl: './partnership.component.html',
	styleUrls: ['./partnership.component.scss'],
})
export class PartnershipComponent {
	// ** 聯絡我們顯示與否
	contactFormShow = false;

	constructor() {}
}
